import React, { Component } from "react";
import { connect } from "react-redux";
import R from "ramda";
import { loadNotifications } from "../actions/portalActions";
import CommunicatedPresentation from "./CommunicatedPresentation";
import { thStyles } from "../../components/tableStyles";

const headingStyle = {
    color: "#28313E",
    fontWeight: "bold",
    margin: 0,
    padding: 10,
    fontSize: "1em",
    borderBottom: "1px solid #ddd",
    backgroundColor: "#eee"
};

class Portal extends Component {
    componentDidMount() {
        this.props.loadNotifications();
    }

    render() {
        return (
            <div style={{fontSize: 14}}>
                <h1 style={headingStyle}>Recommendations sent to you</h1>
                <div style={{borderBottom: "1px solid rgba(0,0,0,0.15)"}}>
                    <table style={{marginLeft: 220, display: "inline-block", width: 610, verticalAlign: "top"}}>
                        <thead>
                        <tr>
                            <th style={Object.assign({}, thStyles, {border: "none", width: 320})} colSpan="3"/>
                            <th style={Object.assign({}, thStyles, {border: "none", width: 60})}>Target Price</th>
                            <th style={Object.assign({}, thStyles, {border: "none", width: 60})}>Market Price</th>
                            <th style={Object.assign({}, thStyles, {border: "none", width: 105})}/>
                        </tr>
                        </thead>
                    </table>
                </div>
                {
                    this.props.notifications && this.props.notifications.length > 0
                                             && R.sort(byCommunicationTimestampDesc, this.props.notifications).map(notification =>
                        notification.presentations.map(presentation => {
                            const key = presentation.legs[0].legId;
                            return <CommunicatedPresentation key={key} communicationDetails={notification} presentation={presentation} />;
                        })
                    )
                }
                {
                    this.props.notifications && this.props.notifications.length === 0 && <p style={{ padding: ".5em"}}>No disclosures so far.</p>
                }
            </div>
        );
    }
}
Portal.propTypes = {
    notifications: React.PropTypes.arrayOf(React.PropTypes.object)
};

const byCommunicationTimestampDesc = R.comparator((a, b) => a.communicationTimestamp > b.communicationTimestamp);

const mapDispatchToProps = (dispatch, ownProps) => ({
    loadNotifications: () => dispatch(loadNotifications())
});

const mapStateToProps = (state) => ({
    notifications: state.portal.notifications
});

export default connect(mapStateToProps, mapDispatchToProps)(Portal);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/components/Portal.js
 **/